import script from "./ImportsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportsView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__